module.exports = __webpack_public_path__ + "static/media/about_section.9c0d6559.svg";